import { render, staticRenderFns } from "./LinkGeofenceTab.vue?vue&type=template&id=2dc8c564"
import script from "./LinkGeofenceTab.vue?vue&type=script&lang=js"
export * from "./LinkGeofenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports